import axios from "axios";
// axios.defaults.timeout = 36000000;
export const Axios = axios.create({
  baseURL: "https://drivera-api-heroku.herokuapp.com/api",
  // withCredentials: true
  timeout: 36000000, // 60 seconds
});
// https://drivera-api-heroku.herokuapp.com/api
// http://localhost:5000/api
